/* eslint-disable no-mixed-operators */
/* eslint react/jsx-pascal-case: 0 */
import * as React from "react";
import Search_Result from "../components/Search_Item/Search_Result";
import Search_Refinement_ReportType from "../components/Search_Refinement/Search_Refinement_ReportType";
import Search_Refinement_ReportDate from "../components/Search_Refinement/Search_Refinement_ReportDate";
import Search_Refinement_Department from "../components/Search_Refinement/Search_Refinement_Department";
import Search_Refinement_Division from "../components/Search_Refinement/Search_Refinement_Division";
import Search_Refinement_Author from "../components/Search_Refinement/Search_Refinement_Author";
import Search_ResultShimmer from "../components/Search_Item/Search_ResultShimmer";
import SomethingWentWrong from "../../../core/components/SomethingWentWrong";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import Helper from "../../../core/libraries/Helper";
import Constants from "../../../core/libraries/Constants";
import { IUserProfile } from "../../Auth/types";
import {
  showDialog,
  showToastMessage,
  confirmDialog,
} from "../../Dialog/actions";
import { connect } from "react-redux";
import { RootState } from "../../../store/store";
import { ISearchResultsObj, IRefinements, ISearchResultItem, IRefinement } from "../types";
import { getSearchResultsDispatch, updateURLWithRefinements } from "../thunks";
import { addRefinements, handleSearch } from "../actions";
import _ from "lodash";
import RbLabel from "../../../bosch-react/components/label/RbLabel";
import RbSearchField from "../../../bosch-react/components/search-field/RbSearchField";
import ExpertResults from "../../ExpertPanel/components/ExpertResults";
import classes from "./SearchResults.module.scss";
import { Dialog, DialogFooter, DialogType, Icon, ITooltipHostStyles, TooltipHost } from "@fluentui/react";
import { addSubscription, updateSubscription } from "../../Subscriptions/services";
import { exportToExcel } from "../../../services/excelServices";
import { withRouter } from "react-router-dom";
import { convertToPageNumber, removeAliasDomain } from "../../../utils/converter";
import { ISubscriptionItem } from "../../Subscriptions/types";
import RbButton, { ButtonSize, ButtonType } from "../../../bosch-react/components/button/RbButton";
import { ChoiceGroup, IChoiceGroupOption } from "office-ui-fabric-react";
import { getMySubscriptionDispatch } from "../../Subscriptions/thunks";
import { ISearchedStatistic, StatisticType, insertStatisticData } from "../../Statistics/services";
interface SearchResultsProps {
  // User Profile
  userProfile: IUserProfile | undefined;
  // Utilities
  confirmDialog: typeof confirmDialog;
  showDialog: typeof showDialog;
  showToastMessage: typeof showToastMessage;
  // Search
  isLoading: boolean | null;
  searchResultsObj: ISearchResultsObj | undefined;
  refinements: IRefinements;
  getSearchResultsDispatch: any;
  addRefinements: typeof addRefinements;
  handleSearch: any;
  location: any;
  history: any;
  mySubscriptions: ISubscriptionItem[] | undefined,
  getMySubscriptionDispatch: any
}

class SearchResults extends React.Component<SearchResultsProps, any> {
  constructor(props: SearchResultsProps) {
    super(props);

    this.state = {
      top: 5,
      skip: 0,
      selectedSort: "",
      SearchBoxRef: React.createRef(),
      ReportDateRef: React.createRef(),
      AuthorRef: React.createRef(),
      DepartmentRef: React.createRef(),
      hideDialog: true,
      selectedSubscription: {},
      hasCalledSearch:false,
      // Mobile-only: whether the refinement filters / expert panel accordions are expanded
      isFilterOpen: false,
      isExpertOpen: false,
    };

    this.callSearch = this.callSearch.bind(this);
    this.searchNewText = this.searchNewText.bind(this);
    this.addToSearchedStatistics = this.addToSearchedStatistics.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getReportTypes = this.getReportTypes.bind(this);
    this.getDepartments = this.getDepartments.bind(this);
    this.changeSort = this.changeSort.bind(this);
    this.changeNumberOfResults = this.changeNumberOfResults.bind(this);
    this.addSubscription = this.addSubscription.bind(this);
    this.exportMetaData = this.exportMetaData.bind(this);
    this.refineDivisionName = this.refineDivisionName.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleExpert = this.toggleExpert.bind(this);

  }

  // Mobile-only accordion toggles — no-op visually on desktop where the
  // accordion CSS is disabled and both panels stay always-expanded.
  toggleFilter() {
    this.setState((prevState: any) => ({ isFilterOpen: !prevState.isFilterOpen }));
  }

  toggleExpert() {
    this.setState((prevState: any) => ({ isExpertOpen: !prevState.isExpertOpen }));
  }

  componentDidMount() {
    const params: any = new URLSearchParams(this.props.location.search);

    // Extract params
    const keyword = !_.isUndefined(params.get("keyword"))
      ? Helper.decodeCustomized(decodeURIComponent(params.get("keyword")))
      : "*";
    const pageNumber = Number(params.get("pagenumber") || 1);
    const sortList = params.get("sortList") || "";
    const numberOfResults = Number(params.get("NumberOfResults") || 10);
    const reportType = params.get("reporttype") || "";
    const reportDate = params.get("reportdate") || "";
    const division = params.get("division") || "";
    const department = params.get("department") || "";
    const authors = params.get("author") || "";

    console.log(reportDate);

    // Set default values on refs
    this.state.ReportDateRef.current?.setDefaultValues(reportDate);
    this.state.AuthorRef.current?.setDefaultValues(authors);
    this.state.DepartmentRef.current?.setDefaultValues(department);
    this.state.SearchBoxRef.current?.setValue(keyword);

    this.setState({ selectedSort: sortList });

    // Set the refinements
    this.props.addRefinements([
      { name: "keyword", value: keyword },
      { name: "pagenumber", value: pageNumber },
      { name: "sortList", value: sortList },
      { name: "NumberOfResults", value: numberOfResults },
      { name: "reporttype", value: reportType },
      { name: "reportdate", value: reportDate },
      { name: "division", value: division },
      { name: "department", value: department },
      { name: "author", value: authors },
    ]);

    this.updateURLwithParams([{ name: "keyword", value: keyword }]);

    if (this.props.userProfile && !this.state.hasCalledSearch) {
      this.setState({ hasCalledSearch: true }, () => {
        this.callSearch();
      });
    }
  }

  componentDidUpdate(prevProps: Readonly<SearchResultsProps>) {
  if (!prevProps.userProfile && this.props.userProfile && !this.state.hasCalledSearch) {
    this.setState({ hasCalledSearch: true }, () => {
      this.callSearch();
    });
  }
}

  render() {
    const styles: Partial<ITooltipHostStyles> = {
      root: {
        display: "inline-block",
        fontFamily: "BoschFont",
        fontSize: "1rem",
      },
    };
    const calloutProps = { gapSpace: 0 };
    const tooltipId = "tooltipReportPanel";
    let { searchResultsObj } = this.props

    let pageNumber = convertToPageNumber(searchResultsObj?.top, searchResultsObj?.skip);
    let isMax = !!searchResultsObj && !!searchResultsObj.count && searchResultsObj.skip + searchResultsObj.top >= searchResultsObj.count ? searchResultsObj.count : false;
    let element = (
      <div className={`${classes.Container} ms-Grid`}>
        <Dialog
          hidden={this.state.hideDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: Constants.CONFIRMATION_MESSAGE.SUBSCRIPTION_UPDATE.TITLE,
            closeButtonAriaLabel: 'Close',
          }}
        >
          {!!this.props.mySubscriptions && this.props.mySubscriptions?.length > 0 && <ChoiceGroup defaultSelectedKey="B" options={this.props.mySubscriptions.map(sub => {
            return {
              key: sub.id.toString(),
              text: sub.title
            }
          })} onChange={(event, option) => this.onChangeReplaceSubscription(event, option)} label={Constants.CONFIRMATION_MESSAGE.SUBSCRIPTION_UPDATE.CONTENT} required={true} />}
          <DialogFooter>
            <RbButton
              type={ButtonType.Primary}
              size={ButtonSize.Tiny}
              disabled={this.state.clicked}
              onClick={() => this.replaceSubscription()}
              label="Replace"
            />
            <RbButton
              type={ButtonType.Secondary}
              size={ButtonSize.Tiny}
              disabled={this.state.clicked}
              onClick={() => this.setState({ hideDialog: true })}
              label="Don't change"
            />
          </DialogFooter>
        </Dialog>
        {/* Mobile-only: sticky floating buttons that open the refinement
            filters / expert results as slide-in side panels instead of
            squeezing them into the scrollable content. Hidden on desktop
            via CSS, where both panels are shown inline as normal columns.
            Also hidden while either panel is open, otherwise the FAB
            buttons float on top of the open panel and block its inputs. */}
        {!this.state.isFilterOpen && !this.state.isExpertOpen && (
          <div className="search-fab-group">
            <button
              type="button"
              className={"search-fab-btn" + (this.state.isFilterOpen ? " active" : "")}
              aria-label={this.state.isFilterOpen ? "Close filters" : "Open filters"}
              aria-expanded={this.state.isFilterOpen}
              onClick={this.toggleFilter}
            >
              <Icon iconName="Filter" aria-hidden="true" />
            </button>
            <button
              type="button"
              className={"search-fab-btn" + (this.state.isExpertOpen ? " active" : "")}
              aria-label={this.state.isExpertOpen ? "Close experts" : "Open experts"}
              aria-expanded={this.state.isExpertOpen}
              onClick={this.toggleExpert}
            >
              <Icon iconName="ReminderPerson" aria-hidden="true" />
            </button>
          </div>
        )}
        <div
          className={"search-mobile-panel-backdrop" + ((this.state.isFilterOpen || this.state.isExpertOpen) ? " visible" : "")}
          onClick={() => {
            if (this.state.isFilterOpen) this.toggleFilter();
            if (this.state.isExpertOpen) this.toggleExpert();
          }}
        />
        <div
          className={`ms-Grid-row`}
          style={{ padding: "10px 0" }}
        >
          <div className="ms-Grid-col ms-sm6 search-box-col">
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <h3
                    className={`${classes.panelTitle} ${classes.resultPanelTitle}`}
                  >
                    Search
                  </h3>
                </div>
                <div
                  className={`${classes.searchBoxContainer} ms-Grid-col ms-sm12`}
                >
                  <RbSearchField
                    value={this.props.refinements.keyword}
                    ref={this.state.SearchBoxRef}
                    placeholder="Search..."
                    onSearch={(event, newValue) => this.searchNewText(newValue)}
                    className={`${classes.backgroundColor}`}
                  />
                  <div>
                    <span
                      className="rb-ic rb-ic-import pointer"
                      title="Subscribe"
                      onClick={this.addSubscription}
                    />
                    {!_.isNil(this.props.userProfile?.permissions) ? (
                      this.props.userProfile?.permissions?.checkHasPermission([
                        Constants.PERMISSIONS.ADMIN,
                      ]) ? (
                        <span
                          className="rb-ic rb-ic-document-xls pointer"
                          title="Export"
                          onClick={this.exportMetaData}
                        />
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {/* <span className="rb-ic pointer" style={{ margin: "0px 0.25rem", backgroundColor: "red", height: "25px", width: "25px"}}
                                    onClick={this.exportCustomData}
                                    ></span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ms-Grid-col ms-sm6 search-spacer" />
        </div>
        <div className="ms-Grid-row">
          <br />

          {/* Search Results */}
          <div
            className={`${classes.SearchResultsContainer} ${classes.backgroundColor} ms-Grid-col ms-sm8 search-results-outer-col`}
          >
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                {/* Refinement Area */}
                <div
                  className={"ms-Grid-col ms-sm3 search-refinement-col" + (this.state.isFilterOpen ? " mobile-panel-open" : "")}
                  style={{ paddingRight: 28 }}
                >
                  {/* Mobile-only close button for the slide-in filters panel */}
                  <button
                    type="button"
                    className="search-mobile-panel-close"
                    aria-label="Close filters panel"
                    onClick={this.toggleFilter}
                  >
                    <span className="rb-ic rb-ic-close" aria-hidden="true" />
                  </button>
                  <div className="ms-Grid">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm10">
                        <h3
                          className={`${classes.panelTitle} ${classes.resultPanelTitle}`}
                        >
                          Reports
                        </h3>
                      </div>
                      <div className="ms-Grid-col ms-sm2">
                        <TooltipHost
                          content="FEBER is a Bosch-wide database containing research and development reports"
                          // Give the user more time to interact with the tooltip before it closes
                          closeDelay={1000}
                          id={tooltipId}
                          calloutProps={calloutProps}
                          styles={styles}
                        >
                          <i
                            aria-describedby={tooltipId}
                            className={`${classes.questionFrameIcon} rb-ic-questionFrame`}
                            aria-hidden="true"
                          ></i>
                        </TooltipHost>
                      </div>
                    </div>
                  </div>
                  <Search_Refinement_ReportType
                    inputReportType={this.props.refinements.reportType}
                    handleSearch={this.handleSearch}
                  />
                  <Search_Refinement_ReportDate
                    ref={this.state.ReportDateRef}
                    handleSearch={this.handleSearch}
                  />
                  <Search_Refinement_Department
                    ref={this.state.DepartmentRef}
                    handleSearch={this.handleSearch}
                  />
                  <Search_Refinement_Division
                    inputDivision={this.props.refinements.division}
                    handleSearch={this.handleSearch}
                  />
                  <Search_Refinement_Author
                    ref={this.state.AuthorRef}
                    handleSearch={this.handleSearch}
                  />
                </div>
                <div className="ms-Grid-col ms-sm9 search-results-list-col">
                  <div
                    className="search-minheight-box"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: searchResultsObj?.results?.length! > 0 ? 1297 : 125,
                    }}
                  >
                    {this.props.isLoading == null ? (
                      <SomethingWentWrong />
                    ) : this.props.isLoading === true ? (
                      <div className="ms-Grid">
                        <div
                          className="ms-Grid-row"
                          style={{ marginTop: "10px", marginBottom: "10px" }}
                        >
                          <div className="ms-Grid-col ms-sm12">
                            {Array.from(
                              Array(this.props.refinements.numberOfResults),
                              () => {
                                return (
                                  <Search_ResultShimmer key={Math.random()} />
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div>
                          {/* Search Boxes and Buttons */}
                          <div className="ms-Grid">
                            <div
                              className="ms-Grid-row"
                              style={{
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              {!_.isNil(this.props.userProfile?.permissions) ? (
                                !this.props.userProfile?.permissions?.checkHasPermission(
                                  [
                                    Constants.PERMISSIONS.RND_USER,
                                    Constants.PERMISSIONS.SUPER_ADMIN,
                                  ]
                                ) ? (
                                  <div
                                    className="ms-Grid-col ms-sm12 font-bold font-underline"
                                    style={{}}
                                  >
                                    <RbLabel
                                      style={{
                                        color: "#0000ff",
                                        fontSize: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        Helper.sendCIHotlineRequestRnDRole(removeAliasDomain(this.props.userProfile?.loginName ?? ""), this.props.userProfile?.name ?? "")
                                      }}
                                      title="Click here to send a request email to CI-Hotline"
                                    >
                                      You do not have the rights to view
                                      R&amp;D-Content at the moment. Please click here to
                                      contact your IdM-Administrator/CI-Hotline
                                      and ask for '
                                      {
                                        Constants.IDM_GROUPS.RND_USER
                                      }
                                      '
                                    </RbLabel>
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}

                              <div className="ms-Grid-col ms-sm12" />
                              {/* Sort */}
                              <div
                                className="ms-Grid-col ms-sm6"
                                style={{
                                  paddingTop: "10px",
                                  paddingLeft: "0px",
                                }}
                              >
                                <Dropdown
                                  selectedKey={this.state.selectedSort}
                                  options={Constants.DD_SEARCH_SORT_OPTIONS}
                                  onChange={this.changeSort}
                                />
                              </div>
                              {/* Number of results */}
                              <div
                                className="ms-Grid-col ms-sm6"
                                style={{ paddingTop: "10px" }}
                              >
                                <Dropdown
                                  style={{ float: "right", width: "5rem" }}
                                  selectedKey={
                                    this.props.refinements.numberOfResults
                                  }
                                  options={
                                    Constants.DD_SEARCH_NUMBER_OF_RESULTS
                                  }
                                  onChange={this.changeNumberOfResults}
                                />
                                <RbLabel
                                  style={{
                                    float: "right",
                                    height: "2rem",
                                    paddingTop: "1rem",
                                    paddingRight: "0.5rem",
                                  }}
                                >
                                  Results/Page:&nbsp;
                                </RbLabel>
                              </div>
                              <div className="ms-Grid-col ms-sm12"></div>
                            </div>
                          </div>
                          <div
                            className={`ms-Grid`}
                          >
                            {/* Results */}
                            {Helper.setEmptyArrayIfNull(
                              searchResultsObj?.results
                            ).length > 0
                              ? searchResultsObj?.results.map(
                                (searchResult: ISearchResultItem, index: any) => (
                                  <Search_Result
                                    data={searchResult}
                                    key={index}
                                  />
                                )
                              )
                              : ""}
                          </div>
                        </div>
                        <div>
                          {/* Paging */}
                          {!!searchResultsObj && Helper.setEmptyArrayIfNull(
                            searchResultsObj?.results
                          ).length > 0 ? (
                            <div
                              className="ms-Grid"
                              style={{
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              <div className="ms-Grid-row ms-textAlignCenter">
                                <div className="ms-Grid-col ms-sm12">
                                  {/* Left arrow */}
                                  <span
                                    title="Previous"
                                    className={
                                      "rb-ic rb-ic-back-left" +
                                      (pageNumber === 1
                                        ? "-light-gray"
                                        : " pointer")
                                    }
                                    onClick={() => {
                                      if (pageNumber !== 1) {
                                        this.handleSearch("pagenumber", pageNumber - 1);
                                      }
                                    }}
                                  />

                                  {/* Page numbers */}
                                  <RbLabel
                                    style={{
                                      lineHeight: "3rem",
                                      padding: "1rem",
                                      minWidth: "5vw",
                                      display: "inline-block",
                                    }}
                                  >
                                    {searchResultsObj.count !== 0
                                      ? `${searchResultsObj.skip + 1} - ${!!isMax ? isMax : searchResultsObj.top + searchResultsObj.skip}`
                                      : ""}
                                  </RbLabel>

                                  {/* Right arrow */}
                                  <span
                                    title="Next"
                                    className={
                                      "rb-ic rb-ic-forward-right" +
                                      (isMax
                                        ? "-light-gray"
                                        : " pointer")
                                    }
                                    onClick={() => {
                                      if (!isMax) {
                                        this.handleSearch("pagenumber", pageNumber + 1);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          {/* Total */}
                          <div
                            className="ms-Grid"
                            style={{ marginTop: "10px", marginBottom: "10px" }}
                          >
                            <div className="ms-Grid-row ms-textAlignCenter">
                              <div className="ms-Grid-col ms-sm12">
                                <RbLabel>
                                  {Helper.setZeroIfNull(
                                    searchResultsObj?.count
                                  ) > 0
                                    ? Helper.numberWithComma(
                                      searchResultsObj?.count
                                    ) +
                                    " result" +
                                    (Helper.setZeroIfNull(
                                      searchResultsObj?.count
                                    ) > 1
                                      ? "s"
                                      : "")
                                    : "No result found"}
                                </RbLabel>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${classes.expertPanelContainer} ${classes.backgroundColor} ms-Grid-col ms-sm4 search-expert-col` + (this.state.isExpertOpen ? " mobile-panel-open" : "")}
          >
            {/* Mobile-only close button for the slide-in experts panel */}
            <button
              type="button"
              className="search-mobile-panel-close"
              aria-label="Close experts panel"
              onClick={this.toggleExpert}
            >
              <span className="rb-ic rb-ic-close" aria-hidden="true" />
            </button>
            <ExpertResults keyword={this.props.refinements.keyword} location={this.props.location} />
          </div>
        </div>
      </div>
    );
    return element;
  }
  onChangeReplaceSubscription = (event: any, option: IChoiceGroupOption | undefined) => {
    !!option && this.setState({
      selectedSubscription: { id: option.key, title: option.text }
    })
  }
  replaceSubscription = async () => {
    let selectSubscription = this.state.selectedSubscription;
    let newValue = this.state.SearchBoxRef.current.state.value.trim();
    let success = !!selectSubscription.id && !!newValue && await updateSubscription(selectSubscription.id, newValue);
    !!success && this.props.showToastMessage(
      Constants.TOAST_MESSAGE_CODE.SUCCESS,
      Constants.SUBSCRIPTION_MESSAGE.CREATE.SUCCESS.replace("{0}", newValue)
    ) || this.props.showToastMessage(
      Constants.TOAST_MESSAGE_CODE.ERROR,
      Constants.SUBSCRIPTION_MESSAGE.CREATE.FAILED.replace("{0}", newValue)
    );
    !!this.props.userProfile?.loginName && this.props.getMySubscriptionDispatch(this.props.userProfile?.loginName)
    this.setState({ hideDialog: true })
  }

  callSearch() {
    this.props.getSearchResultsDispatch(this.props.refinements, this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.RND_USER]));
    Helper.runNewTask(async () => {
      await this.addToSearchedStatistics(this.props.refinements.keyword);
    })
  }


  searchNewText(text = "*") {
    let searchedText = text.trim() !== "" ? text.trim() : "*";

    this.props.history.push({
      pathname: process.env.REACT_APP_SEARCH_RESUTLS,
      search: `?keyword=${searchedText}`
    })
    this.updateURLwithParams([
      { name: "keyword", value: searchedText },
      { name: "pagenumber", value: 1 },
    ]);
    this.handleSearch("pagenumber", 1);
  }

  async addToSearchedStatistics(searchedText: string) {
    if (!!this.props.userProfile) {
      const { name, department, division } = this.props.userProfile
      let record: ISearchedStatistic = {
        createdBy: name,
        keyword: searchedText,
        department: department || "",
        division: division || "",
      }
      await insertStatisticData(StatisticType.Searched, record)
    }
  }

  handleSearch(property: string, value: any, shouldCallSearch = true) {
    Helper.runNewTask(() => {
      this.props.handleSearch(
        property,
        value,
        "/SearchResults",
        () => {
          this.updateURLwithParams([{ name: property, value: value }]);
        },
        (href: string) => {
          if (shouldCallSearch === true) {
            if (property.toLowerCase() !== "pagenumber") {
              this.handleSearch("pagenumber", 1, true);
              return;
            }
            this.callSearch();
          }
        }
      );
    });
  }

  getReportTypes(value: any) {
    let result = "";
    if (value === "") {
      // All
      let contentTypesArr = [
        "ResearchReports",
        "LessonsLearned",
        Constants.UPLOAD_TYPE.Thesis,
        Constants.UPLOAD_TYPE.Paper,
      ];
      contentTypesArr.forEach((contentType) => {
        result += " ContentType:" + contentType;
      });
    } else {
      // 1 selected
      result = " ContentType:" + value;
    }
    return result;
  }

  getDepartments(departmentString: any) {
    let result = "";
    let departmentArr = !_.isUndefined(departmentString)
      ? JSON.parse(departmentString)
      : [];
    departmentArr.forEach((department: any) => {
      result += " FeberDepartment:" + department;
    });
    return result;
  }

  changeSort(event: any, option: any) {
    this.setState({ selectedSort: option.key }, () => {
      this.handleSearch("sortList", option.key);
    });
  }

  changeNumberOfResults(event: any, option: any) {
    this.updateURLwithParams([
      {
        name: "NumberOfResults",
        value: Helper.changeSearchNumberOfResultsFromCache(option.key),
      },
    ]);
    this.handleSearch("pagenumber", 1);
  }

  async addSubscription() {
    let value = this.state.SearchBoxRef.current.state.value.trim();
    if (value !== "") {
      let response = !!this.props.userProfile?.loginName && await addSubscription(this.props.userProfile?.loginName, value)
      if (response.success) {
        this.props.showToastMessage(
          Constants.TOAST_MESSAGE_CODE.SUCCESS,
          Constants.SUBSCRIPTION_MESSAGE.CREATE.SUCCESS.replace(
            "{0}",
            value
          )
        );
      }
      else if (response.message === Constants.RESPONSE_EXCEPTIONS.RecordExists) {
        this.props.showToastMessage(
          Constants.TOAST_MESSAGE_CODE.INFO,
          Constants.SUBSCRIPTION_MESSAGE.CREATE.EXISTED.replace(
            "{0}",
            value
          )
        );
      }
      else if (response.message === Constants.RESPONSE_EXCEPTIONS.LimitExeeded) {
        let { mySubscriptions, userProfile } = this.props;
        mySubscriptions === undefined || mySubscriptions.length <= 0
          ? this.props.getMySubscriptionDispatch(userProfile?.loginName, this.setState({ hideDialog: false }))
          : this.setState({ hideDialog: false })
      }
    }
  }


  exportMetaData() {
    const results = this.props.searchResultsObj?.results;
    const date = new Date(Date.now());
    const formattedDate = date.toLocaleDateString('en-US');
    const fileName = `SearchResults_${formattedDate}`
    if (!!results && results.length > 0) {
      const formatedRes = results.map((item: ISearchResultItem) => {
        const { metadata_storage_path, metadata_storage_content_type, score, BlobUrl, ID, Guid, CorrelationId, Modified, ModifiedBy, LowerTitle, content, metadata_storage_size, ...rest } = item;
        return {
          ...rest,
          DocumentDate: Helper.getDateTimeFormatForUI(item.DocumentDate),
          ApprovalDate: Helper.getDateTimeFormatForUI(item.ApprovalDate),
          UploadDate: Helper.getDateTimeFormatForUI(item.UploadDate),
          Created: Helper.getDateTimeFormatForUI(item.Created)
        }
      })
      exportToExcel(formatedRes, fileName)
    }
  }

  refineDivisionName(divisions: any) {
    let result = "";
    let toArrayDivision: any;
    if (typeof divisions === "string") {
      if (divisions === "") {
        return "";
      } else {
        toArrayDivision = divisions.split(",");
        toArrayDivision.forEach((division: any) => {
          result += " FeberDivision:" + division;
        });
      }
    } else {
      if (divisions.length === 0) {
      } else {
        if (divisions.length === 1 && divisions[0] === "") {
          result = "";
        } else {
          divisions.forEach((division: any) => {
            result += " FeberDivision:" + division;
          });
        }
      }
    }
    return result;
  }

  updateURLwithParams(refinements: IRefinement[]) {
    updateURLWithRefinements(
      refinements,
      this.props.location,
      this.props.history,
      this.props.addRefinements
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
  isLoading: state.search.isLoading,
  searchResultsObj: state.search.searchResultsObj,
  refinements: state.search.refinements,
  mySubscriptions: state.subscription.subscriptions
});

export default withRouter(connect(mapStateToProps, {
  confirmDialog,
  showDialog,
  showToastMessage,
  getSearchResultsDispatch,
  addRefinements,
  handleSearch,
  getMySubscriptionDispatch,
})(SearchResults));
